import application from 'application/application';

import template from './publications-details.template.html';

import controller from './publications-details.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.publications.publicationsDetails', {
				url: ':id&idUsuarioCliente',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Detalhe',
					displayName: 'Detalhe'
				}
			});

	}]);
